// config/default.config.js
export default {
  providers: {
    live: "trtc",
    im: "tim",
    whiteboard: "tiw",
  },
  live: {
    trtc: {
      sdkAppId: null,
      userSig: null,
      roomId: null,
      userId: null,
      role: 1, // 1 主播，2 观众
    },
    agora: {
      appId: null,
      certificate: null,
    },
  },
  im: {
    tim: {
      sdkAppId: null,
      userID: null,
      userSig: null,
    },
    easemob: {
      appKey: null,
      clientId: null,
      clientSecret: null,
    },
  },
  whiteboard: {
    tiw: {
      id: "", // dom节点id
      classId: null, // 课堂 ID，32位整型，取值范围[1, 4294967294]
      sdkAppId: null, // 整数
      userId: null, // 字符串
      userSig: null, // 字符串
    },
    netless: {
      appIdentifier: null,
      region: "cn-hz",
    },
  },
  registerComponents: true, // 是否自动注册组件
};
